import script from "./ImageLightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageLightbox.vue?vue&type=script&setup=true&lang=ts"

import "./ImageLightbox.vue?vue&type=style&index=0&id=1726b244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1726b244"]])

export default __exports__